module.exports = __webpack_public_path__ + "static/media/star.96102a86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/paquetes/ribbon/star.svg
// module id = 217
// module chunks = 0